/* eslint-disable import/prefer-default-export */
import { IntlShape } from "react-intl";

export function getIncotermTranslations(label: string, intl: IntlShape) {
  if (!label) return "";
  switch (label.toLowerCase()) {
    case "EXW - Ex Works".toLowerCase():
      return intl.formatMessage({
        id: "settings.payment-locations.exWorks",
        defaultMessage: "EXW - Ex Works",
      });
    case "FCA - Free Carrier".toLowerCase():
      return intl.formatMessage({
        id: "settings.payment-locations.freeCarrier",
        defaultMessage: "FCA - Free Carrier",
      });
    case "CPT - Carriage Paid To".toLowerCase():
      return intl.formatMessage({
        id: "settings.payment-locations.carriagePaidTo",
        defaultMessage: "CPT - Carriage Paid To",
      });
    case "CIP - Carriage Insurance Paid To".toLowerCase():
      return intl.formatMessage({
        id: "settings.payment-locations.carriageInsurancePaidTo",
        defaultMessage: "CIP - Carriage Insurance Paid To",
      });
    case "DAT - Delivery At Terminal".toLowerCase():
      return intl.formatMessage({
        id: "settings.payment-locations.deliveryAtTerminal",
        defaultMessage: "DAT - Delivery At Terminal",
      });
    case "DAP - Delivery at Place".toLowerCase():
      return intl.formatMessage({
        id: "settings.payment-locations.deliveryAtPlace",
        defaultMessage: "DAP - Delivery at Place",
      });
    case "DDP - Delivery Duty Paid".toLowerCase():
      return intl.formatMessage({
        id: "settings.payment-locations.deliveryDutyPaid",
        defaultMessage: "DDP - Delivery Duty Paid",
      });
    case "FAS - Free Alongside Ship".toLowerCase():
      return intl.formatMessage({
        id: "settings.payment-locations.freeAlongsideShip",
        defaultMessage: "FAS - Free Alongside Ship",
      });
    case "FOB - Free On Board".toLowerCase():
      return intl.formatMessage({
        id: "settings.payment-locations.freeOnBoard",
        defaultMessage: "FOB - Free On Board",
      });
    case "CFR - Cost and Freight".toLowerCase():
      return intl.formatMessage({
        id: "settings.payment-locations.costAndFreight",
        defaultMessage: "CFR - Cost and Freight",
      });
    case "CIF - Cost, Insurance and Freight".toLowerCase():
      return intl.formatMessage({
        id: "settings.payment-locations.costInsuranceFreight",
        defaultMessage: "CIF - Cost, Insurance and Freight",
      });
    case "DPU - Delivered at Place Unloaded".toLowerCase():
      return intl.formatMessage({
        id: "settings.payment-locations.deliveredAtPlaceUnloaded",
        defaultMessage: "DPU - Delivered at Place Unloaded",
      });
    default:
      return label;
  }
}
